module.exports = {
  "version": "0.30.2"
};